export const localDatabaseVersion = 1;
export const appName = "Arthereum";
export const mainCryptoName = "Arthereum";
/** Share links use the origin the user is on, so they always land on an allowed domain. */
export const appUrl =
  typeof window !== "undefined" && window.location.hostname.endsWith(".web.app")
    ? window.location.origin
    : "https://cstry2.web.app";

export enum FONTSIZE {
  PRIMARY = "30px",
  SECONDARY = "24px",
  TERTIARY = "17px",
  QUATERNARY = "15px",
  QUINTERNARY = "12px",
  SIXTERNARY = "9px",
}
export const twitterUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{2,14}$/;

export const imagesUrls = {
  pi: "https://images.pexels.com/photos/19314598/pexels-photo-19314598.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  postCrafter2:
    "https://firebasestorage.googleapis.com/v0/b/connect-social-project.appspot.com/o/robot.jpg?alt=media&token=ec90c4c8-c93e-4c35-a0d8-9263129b13c8",
  job: "https://images.pexels.com/photos/19428999/pexels-photo-19428999.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  ai: "https://images.pexels.com/photos/19022185/pexels-photo-19022185.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  main: "https://images.pexels.com/photos/17059050/pexels-photo-17059050.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  no_ads:
    "https://images.pexels.com/photos/17059071/pexels-photo-17059071.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  privacy:
    "https://images.pexels.com/photos/17059072/pexels-photo-17059072.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  marketplace:
    "https://images.pexels.com/photos/17059057/pexels-photo-17059057.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  rewards:
    "https://images.pexels.com/photos/17073486/pexels-photo-17073486.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  SuperLike:
    "https://images.pexels.com/photos/17073412/pexels-photo-17073412.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  tell: "https://images.pexels.com/photos/17073417/pexels-photo-17073417.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  trades:
    "https://images.pexels.com/photos/17073422/pexels-photo-17073422.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  profile:
    "https://images.pexels.com/photos/17059074/pexels-photo-17059074.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  communities:
    "https://images.pexels.com/photos/17059043/pexels-photo-17059043.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  communities2:
    "https://images.pexels.com/photos/17059047/pexels-photo-17059047.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  communities3:
    "https://images.pexels.com/photos/17059048/pexels-photo-17059048.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  blockchain2:
    "https://images.pexels.com/photos/17073399/pexels-photo-17073399.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  blockchain3:
    "https://images.pexels.com/photos/17073398/pexels-photo-17073398.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  username:
    "https://images.pexels.com/photos/18747869/pexels-photo-18747869.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  password:
    "https://images.pexels.com/photos/18747867/pexels-photo-18747867.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  loginPath:
    "https://images.pexels.com/photos/18747866/pexels-photo-18747866.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  language:
    "https://images.pexels.com/photos/18747865/pexels-photo-18747865.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  grant:
    "https://images.pexels.com/photos/29688885/pexels-photo-29688885.png?auto=compress&cs=tinysrgb&w=800&lazy=load",
  stake:
    "https://images.pexels.com/photos/29688934/pexels-photo-29688934.png?auto=compress&cs=tinysrgb&w=800&lazy=load",
  referral:
    "https://images.pexels.com/photos/29688926/pexels-photo-29688926.png?auto=compress&cs=tinysrgb&w=800&lazy=load",
  gender:
    "https://images.pexels.com/photos/18747863/pexels-photo-18747863.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  email:
    "https://images.pexels.com/photos/18747861/pexels-photo-18747861.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  country:
    "https://images.pexels.com/photos/18747860/pexels-photo-18747860.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  bio: "https://images.pexels.com/photos/18747859/pexels-photo-18747859.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  arthereum:
    "https://images.pexels.com/photos/29554658/pexels-photo-29554658.png?auto=compress&cs=tinysrgb&w=800&lazy=load",
  connectLogo:
    "https://images.pexels.com/photos/18763155/pexels-photo-18763155.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  connectWhiteLogo:
    "https://images.pexels.com/photos/18763157/pexels-photo-18763157.png?auto=compress&cs=tinysrgb&w=600&lazy=load",
  shoes:
    "https://images.pexels.com/photos/18763426/pexels-photo-18763426.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  chooseProfile:
    "https://images.pexels.com/photos/18763425/pexels-photo-18763425.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  food: "https://images.pexels.com/photos/18763424/pexels-photo-18763424.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  computer:
    "https://images.pexels.com/photos/18763423/pexels-photo-18763423.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  clothes:
    "https://images.pexels.com/photos/18763422/pexels-photo-18763422.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  car: "https://images.pexels.com/photos/18763421/pexels-photo-18763421.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  phone:
    "https://images.pexels.com/photos/18763445/pexels-photo-18763445.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  others:
    "https://images.pexels.com/photos/18763451/pexels-photo-18763451.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  name: "https://images.pexels.com/photos/18801069/pexels-photo-18801069.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  description:
    "https://images.pexels.com/photos/18801073/pexels-photo-18801073.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  price:
    "https://images.pexels.com/photos/18801074/pexels-photo-18801074.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  quantity:
    "https://images.pexels.com/photos/18801076/pexels-photo-18801076.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  health:
    "https://images.pexels.com/photos/18801070/pexels-photo-18801070.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  images:
    "https://images.pexels.com/photos/18801071/pexels-photo-18801071.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  location:
    "https://images.pexels.com/photos/18801072/pexels-photo-18801072.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  confirm:
    "https://images.pexels.com/photos/18801075/pexels-photo-18801075.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  news: "https://images.pexels.com/photos/18876072/pexels-photo-18876072.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
};
export function getRandomImageUrl(): any {
  const keys = Object.keys(imagesUrls); // Get the keys of the object
  const randomIndex = Math.floor(Math.random() * keys.length); // Generate a random index
  const randomKey = keys[randomIndex]; // Get a random key from the keys array
  return (imagesUrls as any)?.[randomKey]; // Return the corresponding URL
}
